import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll to top on route changes. Hash-only navigation is handled by the target page. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;

    window.scrollTo(0, 0);
    document.querySelector<HTMLElement>(".teacher-main")?.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
